import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { EYesNo } from '../../../../shared/models/types.enum';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { RMSPlanSummaryService } from '../../../../shared/services/rmsPlanSummary.service';
@Component({
  selector: 'review-rms-plan-summary',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent
  ],
  templateUrl: './review-rms-plan-summary.component.html',
  styleUrl: './review-rms-plan-summary.component.css'
})
export class ReviewRmsPlanSummaryComponent implements OnInit {
  
  @Input() caseId: string | null = null;
  
  yesNo = EYesNo;
  rmsPlanSummary: any | null = null;
  loading: boolean = false;
  
  sections = [
    {
      sectionName: "RMS Plan Completion",
      children: [
        {
          type: 'number',
          questionText: "The Threat Assessment Team for this case certifies that this Response, Management, and Support Plan is complete and has been developed to respond to and manage the threat and to support the student of concern.",
          answer: "certification"
        },
        {
          type: 'string',
          questionText: "Please record any additional notes or instructions needed for the implementation of this RMS Plan:",
          answer: "rms_plan_notes"
        }
      ]
    },
    {
      sectionName: "Official Signature(s)",
      children: [
        {
          type: 'string',
          questionText: "Signature:",
          answer: "user_signature_name"
        },
        {
          type: 'string',
          questionText: "Name:",
          answer: "user_fullname"
        },
        {
          type: 'string',
          questionText: "Email address:",
          answer: "user_email"
        },
        {
          type: 'string',
          questionText: "Title:",
          answer: "user_title"
        },
        {
          type: 'string',
          questionText: "Workphone:",
          answer: "user_workphone"
        },
        {
          type: 'datetime',
          questionText: "Date & Time:",
          answer: "user_date_time"
        }
      ]
    },
  ];

  constructor(
    private rmsPlanSummaryService: RMSPlanSummaryService
  ) { }

  ngOnInit(): void {
    this.loadrmsPlanSummary();
  }
  loadrmsPlanSummary(): void {
    if (this.caseId) {
      this.loading = true;
      this.rmsPlanSummaryService.getRMSPlanSummaryByCaseId(this.caseId).subscribe({
        next: (response) => {
          if (Object.keys(response).length === 0) {
            this.rmsPlanSummary = null;
            this.loading = false;
            return
          } else {
            this.rmsPlanSummary = response;
            this.loading = false;
            return
          }
        },
        error: (error) => {
          console.error('Error:', error);
        }
      });
    }
  }


  showTrueFalse(answer: number): string {
    switch (answer) {
      case 0: return 'False';
      case 1: return 'True';
      case 2: return 'Need More Information';
      default: return 'N/A';
    }
  }

}
